import { Http, Response, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Attachments, DocLibraryAttachmentsVM, DocLibraryAuditTrailsVM, DocLibraryImplementAuditVM, DocLibraryImplmentsVM, DocLibraryVM, GETDocStatus, GETDocTpe, GETModels } from '../entities/global/model';
import { GETImplementWarrantyVM, WarrantyTypeVM } from '../../customer-contact/Models/customer-contact.model';
import { Tuple3 } from '../../../../app/entities';

@Injectable()
export class DocumentLibraryService {

  constructor(private _http: Http) { }
  

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
}


public GetGETModelList(): Observable<GETModels[]> {
  return this._http.get('api/DocumentLibrary/GetGETModelList').share().map(
    (response: Response) => <GETModels[]>response.json()).catch(this.handleError);
}

public GetGETDocType(): Observable<GETDocTpe[]> {
  return this._http.get('api/DocumentLibrary/GetGETDocType').share().map(
    (response: Response) => <GETDocTpe[]>response.json()).catch(this.handleError);
}

public GetGEDocStatus(): Observable<GETDocStatus[]> {
  return this._http.get('api/DocumentLibrary/GetGEDocStatus').share().map(
    (response: Response) => <GETDocStatus[]>response.json()).catch(this.handleError);
}

public addNewDocumentLibrary(existingTemplate: DocLibraryVM): Observable<number> {
  return this._http.post("api/DocumentLibrary/addNewDocumentLibrary", existingTemplate).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
} 

public addAttachmentsForDocumentLibrary(existingTemplate: Attachments[], docID:number, isAddedToAsset:boolean ): Observable<number> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('docID', docID.toString());
  params.set('isAddedToAsset', isAddedToAsset.toString());
  return this._http.post("api/DocumentLibrary/addAttachmentsForDocumentLibrary", existingTemplate, {search: params}).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
} 


public addNewDocumentLibraryAuditTrailGlobal(existingTemplate: DocLibraryAuditTrailsVM, ): Observable<boolean> {
  return this._http.post("api/DocumentLibrary/addNewDocumentLibraryAuditTrailGlobal", existingTemplate).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
} 


public getAuditTrails(DocID: number): Observable<DocLibraryAuditTrailsVM[]> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('DocID', DocID.toString());
  return this._http.get('Api/DocumentLibrary/getAuditTrails', { search: params }).share().map(
      (response: Response) => <DocLibraryAuditTrailsVM[]>response.json()).catch(this.handleError);
}


public SearchDocumnetLibraries(searchFields: DocLibraryVM): Observable<DocLibraryVM[]> {
  return this._http.post("api/DocumentLibrary/SearchDocumnetLibraries", searchFields).share().map(
      (response: Response) => <DocLibraryVM[]>response.json()).catch(this.handleError);
} 

public getSearchedDocLibraryInfromation(DocID: number): Observable<DocLibraryVM> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('DocID', DocID.toString());
  return this._http.get('Api/DocumentLibrary/getSearchedDocLibraryInfromation', { search: params }).share().map(
      (response: Response) => <DocLibraryVM>response.json()).catch(this.handleError);
}


public getAttachmentsDocLibraryInfromation(DocID: number): Observable<Attachments[]> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('DocID', DocID.toString());
  return this._http.get('Api/DocumentLibrary/getAttachmentsDocLibraryInfromation', { search: params }).share().map(
      (response: Response) => <Attachments[]>response.json()).catch(this.handleError);
}



public updateAttachmentsForDocumentLibrary(existingTemplate: Attachments[], DocId:number, isAddedToAsset:boolean): Observable<number> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('DocId', DocId.toString());
  params.set('isAddedToAsset', isAddedToAsset.toString());
  return this._http.post("api/DocumentLibrary/updateAttachmentsForDocumentLibrary", existingTemplate, {search: params}).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
} 


public GetDocumentsForImplement(ImplementId: number): Observable<DocLibraryImplmentsVM[]> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('ImplementId', ImplementId.toString());
  return this._http.get("api/DocumentLibrary/LoadDocumentsForImplement", { search: params }).share().map(
    (response: Response) => <DocLibraryImplmentsVM[]>response.json()).catch(this.handleError);
}

public GetGlobleDocuments(ImplementId: number): Observable<DocLibraryImplmentsVM[]> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('ImplementId', ImplementId.toString());
  return this._http.get("api/DocumentLibrary/LoadGlobalDocuments", { search: params }).share().map(
    (response: Response) => <DocLibraryImplmentsVM[]>response.json()).catch(this.handleError);
}

public IncludeAssetDocument(DocId:number,ImplementId: number): Observable<any> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('DocId', DocId.toString());
  params.set('ImplementId', ImplementId.toString());
  return this._http.get("api/DocumentLibrary/IncludeAssestDocumentFromGlobal", { search: params }).share().map(
    (response: Response) => <string>response.json()).catch(this.handleError);
}

public RemoveAssetDocumnet(DocId:number,ImplementId: number): Observable<any> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('DocId', DocId.toString());
  params.set('ImplementId', ImplementId.toString());
  return this._http.get("api/DocumentLibrary/RemoveAssetDocumnet", { search: params }).share().map(
    (response: Response) => <string>response.json()).catch(this.handleError);
}


public UpdateAssestAttachment(searchFields: DocLibraryAttachmentsVM): Observable<boolean> {
  return this._http.post("api/DocumentLibrary/UpdateAssestAttachment", searchFields).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
} 
public LoadSelectedDocumentAttachmentForImplement(AttachmentId:number): Observable<string> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('AttachmentId', AttachmentId.toString());
  return this._http.get("api/DocumentLibrary/LoadSelectedDocumentAttachmentForImplement", { search: params }).share().map(
    (response: Response) => <string>response.json()).catch(this.handleError);
}

public LoadSelectedDocumentAttachmentForGlobal(AttachmentId:number): Observable<string> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('AttachmentId', AttachmentId.toString());
  return this._http.get("api/DocumentLibrary/LoadSelectedDocumentAttachmentForGlobal", { search: params }).share().map(
    (response: Response) => <string>response.json()).catch(this.handleError);
}

public LoadAuditTrailForImplementDocument(DocId:number,ImplementId: number): Observable<DocLibraryImplementAuditVM[]> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('DocId', DocId.toString());
  params.set('ImplementId', ImplementId.toString());
  return this._http.get("api/DocumentLibrary/LoadAuditTrailForImplementDocument", { search: params }).share().map(
    (response: Response) => <DocLibraryImplementAuditVM[]>response.json()).catch(this.handleError);
}


///warranty services
public LoadAllWarantyList(): Observable<WarrantyTypeVM[]> {
  return this._http.get('api/WarrantyManagement/GetAllWarrantyTypes').share().map(
    (response: Response) => <WarrantyTypeVM[]>response.json()).catch(this.handleError);
}

public SaveOrUpdateWarranty(info: WarrantyTypeVM): Observable<boolean> {
  return this._http.post("api/WarrantyManagement/SaveOrUpdateWarranty", info).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
} 

// public GetWarrantyTypesforImplement(ImplementID:number): Observable<GETImplementWarrantyVM> {
//   return this._http.get('api/WarrantyManagement/GetWarrantyTypesforImplement').share().map(
//     (response: Response) => <GETImplementWarrantyVM>response.json()).catch(this.handleError);
// }

public GetWarrantyTypesforImplement(ImplementID:number): Observable<GETImplementWarrantyVM> {
  let params: URLSearchParams = new URLSearchParams(); 
  params.set('ImplementID', ImplementID.toString());
  return this._http.get("api/WarrantyManagement/GetWarrantyTypesforImplement", { search: params }).share().map(
    (response: Response) => <GETImplementWarrantyVM>response.json()).catch(this.handleError);
}

public UpdateWarrntyImplementLevel(warrantyInfo: GETImplementWarrantyVM, ImplementID:number, equipmentID:number): Observable<boolean> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('ImplementID', ImplementID.toString());
  params.set('equipmentID', equipmentID.toString());
 
  return this._http.post("api/WarrantyManagement/UpdateWarrntyImplementLevel", warrantyInfo, {search: params}).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
} 


public LoadImplmentAttchedToEquipmentInfo(ImplementID:number): Observable<Tuple3> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('ImplementID', ImplementID.toString());
  return this._http.get("api/WarrantyManagement/LoadImplmentAttchedToEquipmentInfo", {search: params}).share().map(
      (response: Response) => <Tuple3>response.json()).catch(this.handleError);
} 

public recordExporedWarrantyforImplement(implementId:number): Observable<boolean> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('implementId', implementId.toString());

  return this._http.get("api/WarrantyManagement/recordExporedWarrantyforImplement", {search: params}).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
}
 
}
